import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select } from "antd";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IAddNews } from "types";
import { getBase64Img } from "utils";

const { Option } = Select;

export const AddNewsModal: React.FC<IAddNews> = ({ ...props }) => {
	const [value, setValue] = useState<string>("");
	const [option, setOption] = useState<string>("");
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasAdded, setImageWasAdded] = useState<boolean>(false);

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		newsStatus,
		currentImgURL,
		setNewsStatus,
		newsIsHighlight,
		setNewsIsHighlight,
		onCreated,
	} = props;

	const setIsActiveAndReviewStatus = (isActiveParam: boolean) => {
		setIsActive(isActiveParam)
		if(!isActiveParam) {
			setNewsStatus(false)
		}
	}
	
	const handleRegister = (values: any) => {
		api
			.post("/news", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					if(onCreated) {
						onCreated(result.data);
					}
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setCurrentImgURL("");
						setNewsStatus(false);
						setNewsIsHighlight(false);
						setIsActive(false);
						setValue("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Cadastrar nova notícia</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar notícia"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						const allValues = imageWasAdded
							? {
									...values,
									content: value,
									image: currentImgURL,
									visibility: option,
									is_active: isActive,
									is_highlight: newsIsHighlight,
									status: newsStatus ? "publish" : "pending",
							  }
							: {
									...values,
									content: value,
									visibility: option,
									is_active: isActive,
									is_highlight: newsIsHighlight,
									status: newsStatus ? "publish" : "pending",
							  };
						handleRegister(allValues);
					})
					.catch((info) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				form.resetFields();
				setCurrentImgURL("");
				setNewsStatus(false);
				setNewsIsHighlight(false);
				setIsActive(false);
				setValue("");
			}}
			className="m-modal-news"
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={setCurrentImgURL}/>

				<div className="row mt-2">
					<Form.Item
						label="Título"
						name="title"
						rules={[
							{
								required: true,
								message: "Título necessário",
							},
						]}
					>
						<Input placeholder="Título da notícia" />
					</Form.Item>
					<Form.Item
						label="Descrição"
						name="description"
						rules={[
							{
								required: true,
								message: "Descrição necessária",
							},
						]}
					>
						<Input placeholder="Descrição da notícia" />
					</Form.Item>

					<div className="col-12 col-md-4">
						<Form.Item
							label="Visibilidade"
							name="visibility"
							rules={[
								{
									required: true,
									message: "Visibilidade necessária",
								},
							]}
							style={{ margin: 0, width: "100%" }}
						>
							<Select
								placeholder="Visibilidade"
								className="m-news-modal__select"
								onChange={(e) => setOption(e)}
							>
								<Option value="public">Público</Option>
								<Option value="private">Privado</Option>
							</Select>
						</Form.Item>
					</div>
					<div className="col-12 col-md-8">
						<div className="row row-cols-3 pb-3 align-items-center text-center">
							<div>
								<p>Publicado</p>
								<Switch
									disabled={isActive === false}
									checked={newsStatus}
									onClick={(e) => setNewsStatus(e)}
								/>
							</div>
							<div>
								<p>Destacar</p>
								<Switch
									checked={newsIsHighlight}
									onClick={(e) => setNewsIsHighlight(e)}
								/>
							</div>
							<div>
								<p>Ativo</p>
								<Switch checked={isActive} onClick={(e) => setIsActiveAndReviewStatus(e)} />
							</div>
						</div>
					</div>
				</div>

				<div className="m-news-modal__textarea">
					<ReactQuill theme="snow" value={value} onChange={setValue} placeholder="Conteúdo da notícia"/>
				</div>
			</Form>
		</Modal>
	);
};
